import cx from 'classnames'
import { Typography } from '@mui/material'
import { format, isToday, Locale } from 'date-fns'
import styles from './TodayTypo.module.css'
import { SchedulerView } from '../../types.ts'

interface TodayTypoProps {
  date: Date
  locale: Locale
  view?: SchedulerView
  onClick?(day: Date): void
}

const TodayTypo = ({
  date,
  locale,
  view = 'week',
  onClick,
}: TodayTypoProps) => {
  const isForToday = isToday(date)
  return (
    <div
      className={cx(styles.TodayTypo, {
        [styles.isToday]: isForToday,
      })}
    >
      <Typography
        style={{
          fontWeight: isForToday ? 'bold' : 'inherit',
        }}
        color={isForToday ? 'primary' : 'inherit'}
        className={onClick ? 'rs__hover__op' : ''}
        onClick={(e) => {
          e.stopPropagation()
          if (onClick) onClick(date)
        }}
      >
        {format(date, 'dd', { locale: locale })}
      </Typography>
      <Typography
        color={isForToday ? 'primary' : 'inherit'}
        style={{
          fontWeight: isForToday ? 'bold' : 'inherit',
          fontSize: 11,
        }}
      >
        {view === 'weekday'
          ? format(date, 'MMM', { locale: locale })
          : format(date, 'eee', { locale: locale })}
      </Typography>
    </div>
  )
}

export default TodayTypo
